import React, { useState, useEffect } from "react";
import styles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import { getInstitutions } from "../../api/institutions";
import { getPeriodTypes } from "../../api/periodTypes";
import { getCampus } from "../../api/campus";

const defaultForm = {
  institucion: "",
  anio: "",
  tipoPeriodo: "",
  periodo: "",
  inicio: "",
  fin: "",
  inscripcion: "",
  reinscripcion: "",
  califParcial1: "",
  califParcial2: "",
  examenExtra: "",
  campus: "",
  estado: "ACTIVO",
  estado_ciclo: "PLANEADO"
};

export default function NuevaSeccionModal({ open, onClose, onSubmit, editMode = false, cicloData = null }) {
  console.log('🎯 NuevaSeccionModal - Componente renderizado, open:', open);
  
  const [form, setForm] = useState(defaultForm);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [instituciones, setInstituciones] = useState([]);
  const [tiposPeriodo, setTiposPeriodo] = useState([]);
  const [campusList, setCampusList] = useState([]);

  const requiredFields = {
    institucion: 'Institución',
    campus: 'Campus',
    anio: 'Año',
    tipoPeriodo: 'Tipo de periodo',
    periodo: 'Periodo',
    inicio: 'Fecha de inicio',
    fin: 'Fecha de fin',
    inscripcion: 'Fecha límite de inscripción',
    reinscripcion: 'Fecha límite de reinscripción',
  };

  useEffect(() => {
    console.log('🔔 NuevaSeccionModal - useEffect ejecutado, open:', open);
    if (open) {
      console.log('📂 NuevaSeccionModal - Modal abierto, llamando loadData()...');
      loadData();
      // Cargar datos del ciclo en modo edición
      if (editMode && cicloData) {
        console.log('📝 NuevaSeccionModal - Cargando datos para edición:', cicloData);
        // Mostrar todas las claves y valores del ciclo para depurar
        Object.entries(cicloData).forEach(([k, v]) => console.log('Campo ciclo:', k, v));
        setForm({
          institucion: cicloData.id_institucion ? String(cicloData.id_institucion) : '',
          anio: cicloData.anio ? String(cicloData.anio) : '',
          tipoPeriodo: cicloData.id_tipo_periodo ? String(cicloData.id_tipo_periodo) : '',
          periodo: cicloData.numero_periodo ? String(cicloData.numero_periodo) : '',
          inicio: cicloData.fecha_inicio || '',
          fin: cicloData.fecha_fin || '',
          inscripcion: cicloData.fecha_limite_inscripciones || '',
          reinscripcion: cicloData.fecha_limite_reinscripciones || '',
          califParcial1: cicloData.fecha_captura_parcial1 || '',
          califParcial2: cicloData.fecha_captura_parcial2 || '',
          examenExtra: cicloData.fecha_captura_parcial3 || '',
          campus: cicloData.id_campus !== undefined && cicloData.id_campus !== null
            ? String(cicloData.id_campus)
            : (cicloData.campus !== undefined && cicloData.campus !== null ? String(cicloData.campus) : ''),
          estado: cicloData.activo ? 'ACTIVO' : 'INACTIVO',
          estado_ciclo: cicloData.estado_ciclo || 'PLANEADO'
        });
      } else {
        setForm(defaultForm);
      }
      setErrors({});
      setSubmitError('');
    }
  }, [open, editMode, cicloData]);

  const loadData = async () => {
    try {
      console.log('🔄 NuevaSeccionModal - Cargando datos...');
      
      // Cargar instituciones
      const instData = await getInstitutions();
      console.log('📥 NuevaSeccionModal - Instituciones:', instData);
      setInstituciones(instData);
      
      // Cargar TODOS los tipos de período sin filtrar por institución
      console.log('🔄 NuevaSeccionModal - Llamando getPeriodTypes()...');
      const tiposData = await getPeriodTypes();
      console.log('📥 NuevaSeccionModal - Tipos de período recibidos:', tiposData);
      console.log('📊 NuevaSeccionModal - Total tipos de período:', tiposData ? tiposData.length : 0);
      setTiposPeriodo(tiposData || []);
      
      // Cargar campus
      const campusData = await getCampus();
      console.log('📥 NuevaSeccionModal - Campus:', campusData);
      setCampusList(campusData);

      // Si estamos en modo edición y cicloData existe, fuerza el campus en el form
      if (editMode && cicloData && cicloData.id_campus !== undefined) {
        setForm((prevForm) => ({
          ...prevForm,
          campus: String(cicloData.id_campus)
        }));
      }

      console.log('✅ NuevaSeccionModal - Todos los datos cargados correctamente');
    } catch (error) {
      console.error('❌ NuevaSeccionModal - Error al cargar datos:', error);
    }
  };

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    Object.entries(requiredFields).forEach(([key, label]) => {
      const value = form[key];
      if (value === undefined || value === null || String(value).trim() === '') {
        newErrors[key] = `${label} es obligatorio`;
      }
    });

    if (form.anio && !/^\d{4}$/.test(String(form.anio))) {
      newErrors.anio = 'El año debe tener 4 dígitos';
    }

    if (form.inicio && form.fin && form.inicio >= form.fin) {
      newErrors.fin = 'La fecha de fin debe ser posterior a la fecha de inicio';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');

    if (!validateForm()) {
      return;
    }

    // Enviar id_campus en vez de campus
    const formToSend = { ...form, id_campus: form.campus };
    delete formToSend.campus;
    console.log('Valor campus:', form.campus);
    console.log('Payload enviado:', formToSend);
    try {
      setSubmitting(true);
      const ok = await onSubmit?.(formToSend);
      if (ok) {
        setForm(defaultForm);
        onClose?.();
      }
    } catch (error) {
      setSubmitError(error.message || 'Error al guardar ciclo escolar');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader} style={{ background: '#d1d1d1', padding: '18px 24px 12px', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
          <h2 style={{ fontWeight: 700, fontSize: '20px', margin: 0 }}>
            {editMode ? 'Editar Ciclo' : 'Nuevo Ciclo'}
          </h2>
        </div>
        <form className={styles.modalBody} style={{ display: 'flex', flexDirection: 'column', gap: '18px', padding: '24px 32px 32px' }} onSubmit={handleSubmit}>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Institución <span style={{ color: '#c62828' }}>*</span></label>
              <select name="institucion" value={form.institucion} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px', color: '#222' }}>
                <option value="">-- Selecciona una institución --</option>
                {instituciones.map(inst => (
                  <option key={inst.id} value={inst.id}>{inst.name}</option>
                ))}
              </select>
              {errors.institucion && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.institucion}</span>}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Campus <span style={{ color: '#c62828' }}>*</span></label>
              <select name="campus" value={form.campus || ''} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px', color: '#222' }}>
                <option value="">-- Asignar campus --</option>
                {campusList.map(campus => (
                  <option key={campus.id} value={String(campus.id)}>{campus.nombre}</option>
                ))}
              </select>
              {errors.campus && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.campus}</span>}
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Año <span style={{ color: '#c62828' }}>*</span></label>
              <input name="anio" value={form.anio} onChange={handleChange} className={styles.input} type="number" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.anio && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.anio}</span>}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Tipo de periodo <span style={{ color: '#c62828' }}>*</span></label>
              <select name="tipoPeriodo" value={form.tipoPeriodo} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px', color: '#222' }}>
                <option value="">-- Selecciona tipo de periodo --</option>
                {tiposPeriodo.map(tp => (
                  <option key={tp.id} value={tp.id}>{tp.nombre}</option>
                ))}
              </select>
              {errors.tipoPeriodo && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.tipoPeriodo}</span>}
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Periodo <span style={{ color: '#c62828' }}>*</span></label>
              <input name="periodo" value={form.periodo} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.periodo && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.periodo}</span>}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}></div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha de inicio <span style={{ color: '#c62828' }}>*</span></label>
              <input name="inicio" value={form.inicio} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.inicio && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.inicio}</span>}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha de fin <span style={{ color: '#c62828' }}>*</span></label>
              <input name="fin" value={form.fin} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.fin && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.fin}</span>}
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha límite de inscripción <span style={{ color: '#c62828' }}>*</span></label>
              <input name="inscripcion" value={form.inscripcion} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.inscripcion && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.inscripcion}</span>}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha límite de reinscripción <span style={{ color: '#c62828' }}>*</span></label>
              <input name="reinscripcion" value={form.reinscripcion} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
              {errors.reinscripcion && <span style={{ color: '#c62828', fontSize: '12px' }}>{errors.reinscripcion}</span>}
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha límite captura Parcial 1</label>
              <input name="califParcial1" value={form.califParcial1} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha límite captura Parcial 2</label>
              <input name="califParcial2" value={form.califParcial2} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Fecha límite captura Parcial 3</label>
              <input name="examenExtra" value={form.examenExtra} onChange={handleChange} className={styles.input} type="date" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Estado del Ciclo</label>
              <select name="estado_ciclo" value={form.estado_ciclo} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px', color: '#222' }}>
                <option value="PLANEADO">PLANEADO</option>
                <option value="ACTIVO">ACTIVO</option>
                <option value="CERRADO">CERRADO</option>
              </select>
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Registro</label>
              <select name="estado" value={form.estado} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', background: form.estado === 'ACTIVO' ? '#e8f5e9' : '#ffebee', color: form.estado === 'ACTIVO' ? '#2e7d32' : '#c62828', fontWeight: 700, padding: '0 10px' }}>
                <option value="ACTIVO">ACTIVO</option>
                <option value="INACTIVO">INACTIVO</option>
              </select>
            </div>
          </div>
          {submitError && (
            <div style={{ color: '#c62828', fontSize: '13px', fontWeight: 600 }}>
              {submitError}
            </div>
          )}
          <div style={{ display: 'flex', gap: '18px', marginTop: '18px', justifyContent: 'center' }}>
            <button type="submit" disabled={submitting} style={{ background: '#1a3764', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)', opacity: submitting ? 0.7 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }}>{submitting ? 'GUARDANDO...' : 'GUARDAR'}</button>
            <button type="button" disabled={submitting} style={{ background: '#b7b7b7', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.10)', opacity: submitting ? 0.7 : 1, cursor: submitting ? 'not-allowed' : 'pointer' }} onClick={onClose}>CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  );
}
